/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_TitleInputs */

const en_gc_story_title = /** @type {(inputs: Gc_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your GridCraft ArtCraft guide.`)
};

const zh_gc_story_title = /** @type {(inputs: Gc_Story_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 GridCraft ArtCraft 指南。`)
};

/**
* | output |
* | --- |
* | "Your GridCraft ArtCraft guide." |
*
* @param {Gc_Story_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_title = /** @type {((inputs?: Gc_Story_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_title(inputs)
	return zh_gc_story_title(inputs)
});
export { gc_story_title as "gc.story.title" }